@if (showOnboarding) {
  <div class="container on-boarding-wrapper">
    <div class="on-boarding">
      <div class="slides">
      <amdocs-swiper class="swipes" [items]="[1, 2, 3, 4,5,6]" #amdocsSwiperComponent [spaceBetween]="0" [allowTouchMove]="true">
        {{currentItemValue}}
        <ng-template let-item #swiperContentItem >
          @if (item === 1) {
            <div class="slide-wrapper">
                <div class="lotti-wrapper">
                  <img src="/assets/gifs/intropagePing.gif" />
                </div>
            </div>
          }
          @if (item === 2) {
            <div class="slide-wrapper">
                <div class="lotti-wrapper">
                  <img src="/assets/gifs/pingHome.gif" />
                </div>
            </div>
          }
          @if (item === 3) {
            <div class="slide-wrapper">
              <div class="lotti-wrapper">
                <img src="/assets/gifs/allApps.gif" />
              </div>
            </div>
          }
          @if (item === 4) {
            <div class="slide-wrapper">
              <div class="lotti-wrapper">
                <img src="/assets/gifs/CustomiseMenu.gif" />
              </div>
            </div>
          }
          @if (item === 5) {
            <div class="slide-wrapper" (click)="onItemClick(item)">
              <div class="lotti-wrapper">
                <img src="/assets/gifs/reportingHours.gif" />
              </div>
            </div>
          }
            @if (item === 6) {
            <div class="slide-wrapper" (click)="onItemClick(item)">
              <div class="lotti-wrapper">
                <img src="/assets/gifs/LetsGo.gif" />
              </div>
            </div>
          }
        </ng-template>
      </amdocs-swiper>
      </div>
      <div>
      @if (currentItemValue !== 4) {
        <button class="btn btn-medium primary next" (click)="next()">{{amdocsContentConstant?.onBoarding.buttons.next }}
        </button>
      }
      @if (amdocsSwiperComponent?.currentItem === 4) {
        <button class="btn btn-medium primary next" (click)="skip()">
          {{amdocsContentConstant?.onBoarding.buttons.finish }}
        </button>
      }
      <button class="btn btn-tiny white skip" (click)="skip()">{{amdocsContentConstant?.onBoarding.buttons.skip }}</button>
      </div>
    </div>
  </div>
}
